import axios from 'axios';

export const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Axios interceptor for auth token
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default axios;
